    
    <div class="msg-atch-tmp" *ngIf="dataSource.data.length > 0; else noTemplateView" >
    <one-table #msgAttachmentTable>
      <one-table-content>
        <mat-table [dataSource]="dataSource" matSort multiTemplateDataRows
         cdkDropList
         [cdkDropListData]="dataSource.data"
         (cdkDropListDropped)="drop($event)">
 
          <ng-container matColumnDef="dragHandle">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon class="drag-handle-icon">drag_indicator</mat-icon>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="selectText">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let row" style="position: absolute; margin-left: 5%;">
              <mat-radio-button class="radio-button" (change)="$event ? selection.toggle(row) : null; selectedRow = row; updateSelectRowStatus();"
              (click)="$event.stopPropagation()"            
              [disabled]="row.iconSets === 'yes-icon'" >     
              {{row.templateDetails.templateSubject}}           
              </mat-radio-button>  
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="messageTemplate">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element" >           
              <div  style="max-width:83%; margin-left:5%; margin-top: 7%;" >
                <dl-rich-text-document class="cdk-hide-rich-text-doc"  [jsonTextItem]="element.templateDetails.templateBody" [showInEditor]="'template'"></dl-rich-text-document>              
              </div>             
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="iconSets">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element; let inx = dataIndex" style="position: absolute; margin-left: 91%;">
              <div>
                <button [matMenuTriggerFor]="messageOptionsMenu" mat-icon-button one-icon-button matSuffix>
                  <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="more-icon">more_vertical</mat-icon>
                </button>
                <mat-menu #messageOptionsMenu="matMenu" xPosition="before" oneMenu>
                  <button mat-menu-item (click)="EditMessageTemplate(inx)" class="cf-option-menu-btn">Edit</button>
                  <button mat-menu-item (click)="deleteMessageFromTemplate(element, inx)" class="cf-option-menu-btn">Delete</button>
                </mat-menu>
              </div>
            </mat-cell>
          </ng-container>
        
          <mat-row
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{ checked: selection.isSelected(row), disabled: row.disabled }"
            class="one-element-row message-template-row"
            cdkDrag
            cdkDragLockAxis="y"
            [cdkDragDisabled]="row.disabled"
          ></mat-row>
        </mat-table>
      </one-table-content>
    </one-table>
  </div>
  <ng-template #noTemplateView><p title="No Template present, add new Template.">No Template present, add new Template.</p></ng-template>